import { createNamedContext } from '@utils';
import { ArticleFeedPublisherContextValue, ArticleFormContextValue, ArticleFormCoverImageContextValue } from './interfaces';

export const ArticleIdentifierContext = createNamedContext<string>(undefined, 'Article.Form.Identifier.Context');
export const ArticleFormContext = createNamedContext<ArticleFormContextValue>(undefined, 'Article.Form.Context');
export const ArticleCoverImageContext = createNamedContext<ArticleFormCoverImageContextValue>(undefined, 'Article.Form.CoverImage.Context');

export const ArticleFeedPublisherContext = createNamedContext<ArticleFeedPublisherContextValue>(undefined, 'Article.FeedPublisher.Context');